import clsx from 'clsx'
import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import { rem } from 'polished'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-shrink: 0;
`

const IconWrapper = styled.div`
  &.offset {
    margin-inline-start: ${rem(-6)};
  }
  &.z-1 { z-index: 1; }
  &.z-2 { z-index: 2; }
  &.z-3 { z-index: 3; }
`

interface Props {
  size?: number
}

function StackedLoyaltyTierIcon({ size = 16 }: Props) {
  return (
    <Container>
      <IconWrapper className={clsx('z-1')}>
        <LoyaltyTierIcon tier="bronze" size={size} />
      </IconWrapper>
      <IconWrapper className={clsx('z-3', 'offset')}>
        <LoyaltyTierIcon tier="gold" size={size} />
      </IconWrapper>
      <IconWrapper className={clsx('z-2', 'offset')}>
        <LoyaltyTierIcon tier="silver" size={size} />
      </IconWrapper>
    </Container>
  )
}

export default StackedLoyaltyTierIcon
